import {clsx} from 'clsx'

import type {LinkedPullRequest} from '../../../api/common-contracts'
import {LinkedPullRequestToken} from '../../fields/linked-pr-token'
import {BaseCell} from './base-cell'
import styles from './linked-pull-requests-group.module.css'

interface LinkedPullRequestGroupProps {
  linkedPullRequests: Array<LinkedPullRequest> | undefined
  isDecorative?: boolean
  isWrapping?: boolean
}

export const LinkedPullRequestGroup: React.FC<LinkedPullRequestGroupProps> = ({
  linkedPullRequests,
  isDecorative,
  isWrapping,
}) => {
  return (
    <BaseCell className={clsx(styles.BaseCell, isWrapping && styles.wrapping)}>
      {linkedPullRequests?.map(linkedPullRequest => (
        <LinkedPullRequestToken
          linkedPullRequest={linkedPullRequest}
          tabIndex={-1}
          key={linkedPullRequest.id}
          isDecorative={isDecorative}
        />
      ))}
    </BaseCell>
  )
}
